import React from 'react'
import { Card, Badge, Image } from "react-bootstrap"
import {
  FaUser,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaStar,
  FaFlag,
  FaBuilding,
  FaHome,
  FaRupeeSign,
  FaMousePointer,
} from "react-icons/fa"
import { reactLocalStorage } from 'reactjs-localstorage';
import Display from '../../../util/Display';
import Const from '../../../util/Constants';

class LeadInfoSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.lead;
    this.ProgressOptions = this.model.fields.progress.options;
  }

  render() {
    const { lead, onUpdateLead } = this.props;

    return (
      <Card
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow:
            '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 10px -2px rgba(0, 0, 0, 0.05)',
          border: '1px solid #e5e7eb',
          padding: '0',
          height: '100%',
          overflow: 'hidden'
        }}
      >
        {/* Header Section */}
        <div
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '14px 16px',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'relative',
            borderRadius: '8px'
          }}
        >
          {/* LEFT */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <Image
              src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${lead.firstname}`}
              roundedCircle
              style={{
                width: '48px',
                height: '48px',
                border: '2px solid rgba(255,255,255,0.4)',
                backgroundColor: '#fff',
                flexShrink: 0
              }}
            />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <div style={{ fontSize: '16px', fontWeight: 600 }}>
                {Display.ModelName(lead)}
              </div>

              <div
                style={{
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  opacity: 0.9
                }}
              >
                <FaUser size={12} />
                {Display.FieldValue(lead,"responsible_person",this.model?.fields)}
              </div>

              <div style={{ display: 'flex', gap: '6px', marginTop: '2px' }}>
                <Badge
                  style={{
                    fontSize: '10px',
                    padding: '3px 8px',
                    borderRadius: '12px',
                    background: 'rgba(255,255,255,0.18)',
                    border: '1px solid rgba(255,255,255,0.3)'
                  }}
                >
                  {Display.FieldValue( lead, "progress", this.model.fields )}
                </Badge>

                <Badge
                  style={{
                    fontSize: '10px',
                    padding: '3px 8px',
                    borderRadius: '12px',
                    background:
                      lead?.priority === 'High'
                        ? 'rgba(239,68,68,0.25)'
                        : 'rgba(34,197,94,0.25)',
                    border:
                      lead?.priority === 'High'
                        ? '1px solid rgba(239,68,68,0.4)'
                        : '1px solid rgba(34,197,94,0.4)'
                  }}
                >
                  <FaFlag size={9} style={{ marginRight: 4 }} />
                  {Display.FieldValue(lead, "lead_state", this.model.fields )}
                </Badge>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              background: 'rgba(255,255,255,0.15)',
              padding: '6px 10px',
              borderRadius: '8px'
            }}
          >
            <FaStar size={14} style={{ color: '#fbbf24' }} />
            <span style={{ fontSize: '14px', fontWeight: 600 }}>
              {Display.FieldValue(lead, "lead_score", this.model.fields )}
            </span>
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: '12px' }}>
          {/* Project Details */}
          <div style={{ marginBottom: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
              <div style={{
                width: '4px',
                height: '20px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '2px'
              }} />
              <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: '#111827' }}>Project Details</h4>
            </div>

            <div
              style={{
                backgroundColor: '#f8fafc',
                borderRadius: '8px',
                padding: '16px',
                border: '1px solid #e2e8f0'
              }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '8px'
                }}
              >
                <div>
                  <div style={{ fontSize: '11px', fontWeight: 600 }}>
                    <FaBuilding style={{ marginRight: '6px' }} size={12} />

                    Project
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: 600 }}>
                    {Display.FieldValue(lead, "project", this.model.fields )}
                  </div>
                </div>

                <div>
                  <div style={{ fontSize: '11px', fontWeight: 600 }}>
                    <FaHome style={{ marginRight: '6px' }} size={12} />

                    Property Type
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: 600 }}>
                    {Display.FieldValue(lead, "property_type", this.model.fields )}
                  </div>
                </div>

                <div style={{gridColumn: "1 / -1"}}>
                  <div style={{ fontSize: '11px', fontWeight: 600 }}>
                    <FaRupeeSign style={{ marginRight: '6px' }} size={12} />

                    Budget
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: 600 }}>
                    {Display.FieldValue(lead, "min_budget", this.model.fields)} - 
                    {Display.FieldValue(lead, "max_budget", this.model.fields)}
                  </div>
                </div>

                {/* <div>
                  <div style={{ fontSize: '11px', fontWeight: 600 }}>
                    Timeline
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: 600 }}>
                    {lead.purchaseTimeline || 'Within 3 months'}
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          {/* Contact Info */}
        <div style={{ marginBottom: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <div style={{
              width: '4px',
              height: '20px',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              borderRadius: '2px'
            }} />
            <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: '#111827' }}>Contact Information</h4>
          </div>
            
          <div style={{ display: 'grid', gap: '8px' }}>
            {[
              { icon: <FaPhone style={{ color: '#10b981' }} />, label: 'Contact Number', value: Display.FieldValue(lead, "phone", this.model.fields ) },
              { icon: <FaEnvelope style={{ color: '#ef4444' }} />, label: 'Email', value: Display.FieldValue(lead, "email", this.model.fields ) },
              { icon: <FaMapMarkerAlt style={{ color: '#f97316' }} />, label: 'Address', value: Display.FieldValue(lead, "email", this.model.fields ) },
              { icon: <FaMousePointer style={{ color: '#3b82f6' }} />, label: 'Source', value: Display.FieldValue(lead, "source", this.model.fields ) }
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  gap: '12px',
                  padding: '12px',
                  backgroundColor: '#f8fafc',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  marginBottom: '8px'
                }}
              >
                {item.icon}
                <div>
                  <div style={{ fontSize: '11px', fontWeight: 600 }}>
                    {item.label}
                  </div>
                  <div style={{ fontSize: '14px' }}>{item.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {lead.last_call_feedback ? (
          <div style={{ marginBottom: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
              <div style={{
                width: '4px',
                height: '20px',
                background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                borderRadius: '2px'
              }} />
              <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: '#111827' }}>Last Call</h4>
            </div>
            
            <div style={{ 
              backgroundColor: '#eff6ff', 
              borderRadius: '8px', 
              padding: '16px',
              border: '1px solid #dbeafe'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FaPhone style={{ color: '#3b82f6' }} size={16} />
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>
                    Phone Call
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{ fontSize: '12px', color: '#64748b', fontWeight: '500' }}>
                    {Display.FieldValue(lead, "last_call_date", this.model.fields)}
                  </div>
                </div>
              </div>
              
              <div style={{ marginBottom: '8px' }}>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600', marginBottom: '4px' }}>
                  Feedback
                </div>
                <div style={{ 
                  padding: '10px', 
                  backgroundColor: 'white', 
                  borderRadius: '6px',
                  border: '1px solid #e2e8f0',
                  fontSize: '14px',
                  color: '#475569'
                }}>
                  {Display.FieldValue(lead, "last_call_feedback", this.model.fields)}
                </div>
              </div>
              
              {lead.last_call_comment && (
                <div>
                  <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600', marginBottom: '4px' }}>
                    Comment
                  </div>
                  <div style={{ 
                    padding: '10px', 
                    backgroundColor: 'white', 
                    borderRadius: '6px',
                    border: '1px solid #e2e8f0',
                    fontSize: '14px',
                    color: '#475569',
                    lineHeight: '1.5'
                  }}>
                    {Display.FieldValue(lead, "last_call_comment", this.model.fields)}
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : null}
        {/* Last Visit Section */}
        {lead.last_meeting_feedback ? (
          <div style={{ marginBottom: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
              <div style={{
                width: '4px',
                height: '20px',
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                borderRadius: '2px'
              }} />
              <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: '#111827' }}>Last Site Visit</h4>
            </div>
            
            <div style={{ 
              backgroundColor: '#ecfdf5', 
              borderRadius: '8px', 
              padding: '16px',
              border: '1px solid #a7f3d0'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FaMapMarkerAlt style={{ color: '#10b981' }} size={16} />
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>
                    Site Visit
                  </div>
                </div>
                <div style={{ fontSize: '12px', color: '#64748b', fontWeight: '500' }}>
                  {Display.FieldValue(lead, "last_meeting_date", this.model.fields)}
                </div>
              </div>
              
              <div style={{ marginBottom: lead.lastSiteVisitComment ? '12px' : '0' }}>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600', marginBottom: '4px' }}>
                  Feedback
                </div>
                <div style={{ 
                  padding: '10px', 
                  backgroundColor: 'white', 
                  borderRadius: '6px',
                  border: '1px solid #e2e8f0',
                  fontSize: '14px',
                  color: '#475569'
                }}>
                  {Display.FieldValue(lead, "last_meeting_feedback", this.model.fields)}
                </div>
              </div>
              
              {(lead.last_meeting_comment) && (
                <div>
                  <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600', marginBottom: '4px' }}>
                    Comment
                  </div>
                  <div style={{ 
                    padding: '10px', 
                    backgroundColor: 'white', 
                    borderRadius: '6px',
                    border: '1px solid #e2e8f0',
                    fontSize: '14px',
                    color: '#475569',
                    lineHeight: '1.5'
                  }}>
                    {Display.FieldValue(lead, "last_meeting_comment", this.model.fields)}
                  </div>
                </div>
              )}
            </div>
          </div> 
        ): null}
        </div>
      </Card>
    );
  }
}

export default LeadInfoSidebar